export default "__VITE_ASSET__CIdx4jcu__"